import React, { useEffect } from "react";
import AuthManager from "../../../Common/AuthManager";

function UserIndex(props) {
  useEffect(() => {}, [AuthManager.getAuthUser()]);
  return (
    <React.Fragment>
      <div className="container-fluid">
        <h2>Profile</h2>
        <hr />
        <div className="row">
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#Download"
                type="button"
                role="tab"
                aria-controls="Download"
                aria-selected="true"
              >
                <strong>Profile</strong>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#upload"
                type="button"
                role="tab"
                aria-controls="upload"
                aria-selected="false"
              >
                <strong>json</strong>
              </button>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="Download"
              role="tabpanel"
              aria-labelledby="home-tab"
            ></div>
            <div
              className="tab-pane fade"
              id="upload"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div>
                <pre>{JSON.stringify(AuthManager.getAuthUser(), null, 2)}</pre>
              </div>
            </div>
          </div>
          {/* <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item">
              <a
                className="nav-link active"
                id="home-tab"
                data-toggle="tab"
                href="#home"
                role="tab"
                aria-controls="home"
                aria-selected="true"
              >
                <strong>Profile</strong>
              </a>
            </li>

            <li className="nav-item">
              <a
                className="nav-link"
                id="profile-tab"
                data-toggle="tab"
                href="#jsonprint"
                role="tab"
                aria-controls="jsonprint"
                aria-selected="false"
              >
                <strong>json</strong>
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            ></div>

            <div
              className="tab-pane fade"
              id="jsonprint"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div>
                <pre>{JSON.stringify(AuthManager.getAuthUser(), null, 2)}</pre>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </React.Fragment>
  );
}

export default UserIndex;
